// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 3070 ? "8012d7e2" : chunkId) + "." + {"1804":"f6eef5692221e913","3070":"53f58a34c7f03e6b"}[chunkId] + ".js";
};